import React from 'react';
import { useHistory } from 'react-router-dom';
import useMessages from 'customHook/useMessages';
import { MessageBoxContainer, MessageItem } from './styles';
import ModalReplyFromDashboard from 'screens/ModalReplyFromDashboard';
import { ArrowIcon } from 'assets/icons';
import colors from 'constants/colors';

const MessageBox = ({ active }) => {
  
  const history = useHistory()
  const { data } = useMessages();

  const message = {
    name: 'Nancy Hachisu',
    tenantId: '38b6404c-b90d-405e-a7fb-cab12049fe63',
    roomNumber: '823',
    date: 'Text 20/6/2020 7:48PM',
    message: 'First line of message blah blah yada yada yada truncated…',
  }

  const messageArray = data?.latestIncomingMessages.items?.slice(0, 2)?.map((boxedMessage) => {
    return (
      <MessageItem>
        <div
          className='contentBox' 
          onClick={(event) => {
            if (event.metaKey || event.ctrlKey) {
              // Open new tab with absolute URL
              window.open(`https://pms.rookhotel.com/tenant-details/${boxedMessage.tenantId}`, '_blank', 'noopener,noreferrer');
            } else {
              // Normal navigation
              history.push({pathname: `/tenant-details/${boxedMessage.tenantId}`, state: {communication: true}})
            }
          }}
        >
          <div className='content'>
            <span className='messageWriter'>{boxedMessage.name}</span>
            <span className='roomNumber'>{`Room ${boxedMessage.roomNumber}`}</span>
          </div>
          <div className='dateTime'>{boxedMessage.date}</div>
          <div className='message'>{boxedMessage.message}</div>
        </div>
        <ModalReplyFromDashboard
          iconStyle={`
            width: 46px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color:  ${colors.lightBlue};
            svg {
              width: 20px;
              height: 20px;
              filter: invert(1) brightness(0);
            }
          `}
          buttonIcon={<ArrowIcon />}
          tenantId={boxedMessage.tenantId}
        />
      </MessageItem>
    )
  })

  return (
    <MessageBoxContainer active={active}>
      <MessageItem>
        <div
          className='contentBox' 
          onClick={(event) => {
            if (event.metaKey || event.ctrlKey) {
              // Open new tab with absolute URL
              window.open(`https://pms.rookhotel.com/tenant-details/${message.tenantId}`, '_blank', 'noopener,noreferrer');
            } else {
              // Normal navigation
              history.push({pathname: `/tenant-details/${message.tenantId}`, state: {communication: true}})
            }
          }}
        >
          <div className='content'>
            <span className='messageWriter'>{message.name}</span>
            <span className='roomNumber'>{`Room ${message.roomNumber}`}</span>
          </div>
          <div className='dateTime'>{message.date}</div>
          <div className='message'>{message.message}</div>
        </div>
        <ModalReplyFromDashboard
          iconStyle={`
            width: 46px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color:  ${colors.lightBlue};
            svg {
              width: 20px;
              height: 20px;
              filter: invert(1) brightness(0);
            }
          `}
          buttonIcon={<ArrowIcon />}
          tenantId={message.tenantId}
        />
      </MessageItem>
      <MessageItem>
        <div
          className='contentBox' 
          onClick={(event) => {
            if (event.metaKey || event.ctrlKey) {
              // Open new tab with absolute URL
              window.open(`https://pms.rookhotel.com/tenant-details/${message.tenantId}`, '_blank', 'noopener,noreferrer');
            } else {
              history.push({pathname: `/tenant-details/${message.tenantId}`, state: {communication: true}})
            }
          }}
        >
          <div className='content'>
            <span className='messageWriter'>{message.name}</span>
            <span className='roomNumber'>{`Room ${message.roomNumber}`}</span>
          </div>
          <div className='dateTime'>{message.date}</div>
          <div className='message'>{message.message}</div>
        </div>
        <ModalReplyFromDashboard
          iconStyle={`
            width: 46px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color:  ${colors.lightBlue};
            svg {
              width: 20px;
              height: 20px;
              filter: invert(1) brightness(0);
            }
          `}
          buttonIcon={<ArrowIcon />}
          tenantId={message.tenantId}
        />
      </MessageItem>
    </MessageBoxContainer>
  )
}

export default MessageBox;
